import { render, staticRenderFns } from "./LatestFeeds.vue?vue&type=template&id=36e3b85e&scoped=true&"
import script from "./LatestFeeds.vue?vue&type=script&lang=js&"
export * from "./LatestFeeds.vue?vue&type=script&lang=js&"
import style0 from "./LatestFeeds.vue?vue&type=style&index=0&id=36e3b85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3b85e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDivider,VFlex,VIcon,VImg,VLayout,VProgressCircular,VRow,VSnackbar})
